import { Application } from "./Application";
import { PageHelper } from "./utils/PageHelper";
import { NullMessages } from "./localization/NullMessages";
import { NullCommonPage } from "./ui-components/NullCommonPage";
import { NullDataChannel } from "./controller/NullDataChannel";
import type { CommonPage } from "./ui-components/CommonPage";
import type { Messages } from "./localization/Messages";
import type { DataChannel } from "./controller/DataChannel";
import type { ClaimInfoHeader } from "./ui-components/ClaimInfoHeader";
import type { PageNavigation } from "./ui-components/PageNavigation";
import type { SessionExpiry } from "./session/SessionExpiry";

//
// Note that this will be run on pages without a page header, so it has to work
// even if there isn't page header data available.
//
// WARNING: Avoid putting logic in here that ties together all the bits of the application
//          otherwise, we'll likely have problems with unit tests, at least until
//          we can eliminate jQuery. Unfortunately this is counter-intuitive and not ideal.
//
export class ExclaimApplication implements Application {
    readonly ph: PageHelper;

    readonly locale: string;
    readonly language: string;
    readonly isEdjuster: boolean;

    messages: Messages;
    dataChannel: DataChannel;
    commonPage: CommonPage;

    constructor() {
        this.ph = new PageHelper();

        this.locale = this.ph.locale;
        this.language = this.ph.lang;
        this.isEdjuster = this.ph.getHeaderBoolean('isEdjuster', false);

        // Populated with trivial placeholders to start; startApplication() will
        // populate these further during initialization (this is largely to
        // support unit testing and pages that do not need all objects).
        this.messages = new NullMessages();
        this.dataChannel = new NullDataChannel();
        this.commonPage = new NullCommonPage();
    }

    // Legacy naming
    get Messages(): Messages {
        return this.messages;
    }

    get pageHeader() {
        return this.commonPage.pageHeader;
    }

    get claimInfoHeader(): ClaimInfoHeader {
        return this.commonPage.claimInfoHeader;
    }

    get pageNavigation(): PageNavigation {
        return this.commonPage.pageNavigation;
    }

    get sessionExpiry(): SessionExpiry {
        return this.commonPage.sessionExpiry;
    }
}
